<template>
  <div v-if="showComponent">
    <vs-card>
      <div slot="header">
        <h3>Processo e Datas</h3>
      </div>
      <div>
        <div class="vx-row">
          <!-- Abertura de Processo -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.aberturaProcesso"
              label="Abertura de Processo"
              name="Abertura de Processo"
            />
          </div>

          <!-- Solicitação Sindicância -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.solicitacaoSindicancia"
              label="Solicitação Sindicância"
              name="Solicitação Sindicância"
            />
          </div>

          <!-- Retorno Sindicância -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.retornoSindicancia"
              label="Retorno Sindicância"
              name="Retorno Sindicância"
            />
          </div>

          <!-- Solicitação Vistoria -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.solicitacaoVistoria"
              label="Solicitação Vistoria"
              name="Solicitação Vistoria"
            />
          </div>
        </div>

        <div class="vx-row">
          <!-- Retorno Vistoria -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.retornoVistoria"
              label="Retorno Vistoria"
              name="Retorno Vistoria"
            />
          </div>

          <!-- Cotação -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.cotacao"
              label="Cotação"
              name="Cotação"
            />
          </div>

          <!-- Final Busca -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.finalBusca"
              label="Final Busca"
              name="Final Busca"
            />
          </div>

          <!-- Pagamento Participação -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.pagamentoParticipacao"
              label="Pagamento Participação"
              name="Pagamento Participação"
            />
          </div>
        </div>

        <div class="vx-row">
          <!-- Pagamento Evento -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.pagamentoEvento"
              label="Pagamento Evento"
              name="Pagamento Evento"
            />
          </div>

          <!-- Autorização Reparos -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.autorizacaoReparos"
              label="Autorização Reparos"
              name="Autorização Reparos"
            />
          </div>

          <!-- Limite Autorização Reparos -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.limiteAutorizacaoReparos"
              label="Limite Autorização Reparos"
              name="Limite Autorização Reparos"
            />
          </div>

          <!-- Entrega Veículo -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.entregaVeiculo"
              label="Entrega Veículo"
              name="Entrega Veículo" 
            />
          </div>
        </div>

        <div class="vx-row">
          <!-- Acato Documentação -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.acatoDocumentacao"
              label="Acato Documentação"
              name="Acato Documentação"
            />
          </div>

          <!-- Prazo Aproximado Reparos -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.prazoAproximadoReparos"
              label="Prazo Aproximado Reparos"
              name="Prazo Aproximado Reparos"
            />
          </div>

          <!-- Agendamento Vistoria -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.agendamentoVistoria"
              label="Agendamento Vistoria"
              name="Agendamento Vistoria"
            />
          </div>

          <!-- Conclusão Vistoria -->
          <div class="vx-col lg:w-1/4 w-full mb-2">
            <InputDate
              v-model="formProcessosDatas.conclusaoVistoria"
              label="Conclusão Vistoria"
              name="Conclusão Vistoria"
            />
          </div>
        </div>

        <!-- Localização de Documentação -->
        <div class="vx-row">
          <div class="vx-col lg:w-1/2 w-full mb-2">
            <label class="vs-select--label">Localização de Documentação</label>
            <v-select
              class="selectStyle"
              :options="listLocalizacaoDocumentos"
              name="Localização de Documentação"
              id="Localização de Documentação"
              v-model="formProcessosDatas.idLocalizacaoDocumentacao"
              label="label"
              :reduce="(item) => item.id"
            ></v-select>
          </div>
        </div>
      </div>
    </vs-card>
  </div>
</template>

<script>
import vSelect from 'vue-select';
import InputDate from '../../../../../components/InputDate.vue';

export default {
  props: ['formData', 'dominios'],
  components: {
    InputDate,
    vSelect,
  },
  watch: {
    formData(value) {
      if (!value.processosDatas) {
        this.showComponent = false;
        console.error('ERRO NO CONTRATO DO OBJETO - PROCESSO DATAS FORM');
        return;
      }

      this.formProcessosDatas = Object.assign(
        this.formProcessosDatas,
        value.processosDatas,
      );

      // eslint-disable-next-line vue/no-mutating-props
      this.formData.processosDatas = this.formProcessosDatas;
    },
  },
  data() {
    return {
      showComponent: true,
      formProcessosDatas: {
        aberturaProcesso: null,
        solicitacaoSindicancia: null,
        retornoSindicancia: null,
        solicitacaoVistoria: null,
        retornoVistoria: null,
        cotacao: null,
        finalBusca: null,
        pagamentoParticipacao: null,
        pagamentoEvento: null,
        autorizacaoReparos: null,
        limiteAutorizacaoReparos: null,
        entregaVeiculo: null,
        acatoDocumentacao: null,
        prazoAproximadoReparos: null,
        agendamentoVistoria: null,
        conclusaoVistoria: null,
        idLocalizacaoDocumentacao: null,
      },
      listLocalizacaoDocumentos: [],
    };
  },
  mounted() {
    if (!this.formData.processosDatas) {
      console.error('ERRO NO CONTRATO DO OBJETO - PROCESSO DATAS FORM');
      this.showComponent = false;
    }

    // eslint-disable-next-line vue/no-mutating-props
    this.formData.processosDatas = this.formProcessosDatas;

    this.listLocalizacaoDocumentos = this.dominios.listLocalizacaoDocumentos;
  },
};
</script>

<style scoped>
.selectStyle {
  font-size: 1rem !important;
}

.inputData > input {
  width: 100%;
}
</style>
